// extracted by mini-css-extract-plugin
module.exports = {"footer":"OfflineOrderSyncButton_footer__180sC"};